/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreExternalCostResponseDto } from '../../models/core-external-cost-response-dto';

export interface ExternalCostsControllerDelete$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * External cost ID
 */
  id: string;
}

export function externalCostsControllerDelete(http: HttpClient, rootUrl: string, params: ExternalCostsControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreExternalCostResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, externalCostsControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreExternalCostResponseDto>;
    })
  );
}

externalCostsControllerDelete.PATH = '/o2-core/external-costs/{tenant}/id/{id}';
